/* global API_HOSTNAME:false */
/* global dataLayer:false */
/* global resetAccessibleMessage:false */
/* global setAccessibleMessage:false */
/* global trigger:false */

(function() {
	function shakeForm(form) {
		form.classList.add('shake-animation');

		setTimeout(function() {
			form.classList.remove('shake-animation');
		}, 1000);
	}



	function makeFieldsDisabled(form) {
		const formFields = form.querySelectorAll('input, textarea, select');

		Array.prototype.forEach.call(formFields, function(formField) {
			formField.setAttribute('disabled', 'disabled');
		});
	}



	function makeFieldsEnabled(form) {
		const formFields = form.querySelectorAll('input, textarea, select');

		Array.prototype.forEach.call(formFields, function(formField) {
			formField.removeAttribute('disabled');
		});
	}



	function sendFormData(form) {
		const emailField = form.querySelector('.js-input-email');
		const companyField = form.querySelector('.js-input-company');
		const remarksField = form.querySelector('.js-input-remarks');
		const submitButton = form.querySelector('.js-submit-button');

		trigger(submitButton, 'progress');

		const type = form.getAttribute('data-type') || 'contact';

		var data;

		if (type === 'request-demo') {
			const firstNameField = form.querySelector('.js-input-first-name');
			const lastNameField = form.querySelector('.js-input-last-name');
			const companySizeField = form.querySelector('.js-input-company-size');

			data = {
				SendDemoRequestForm:{
					firstName: firstNameField.value,
					lastName: lastNameField.value,
					email: emailField.value,
					company: companyField.value,
					companySize: companySizeField.value,
					remarks: remarksField.value.trim(),
				},
			};
		} else {
			const nameField = form.querySelector('.js-input-name');
			const phoneField = form.querySelector('.js-input-phone');

			data = {
				SendContactUsForm:{
					name: nameField.value,
					email: emailField.value,
					company: companyField.value,
					phone: phoneField.value,
					remarks: remarksField.value.trim(),
				},
			};
		}

		const prepareResponseOverlayAfterSubmit = function() {
			form.querySelector('.js-submit-response').classList.add('overlay-response--show-overlay');
			form.querySelector('.js-submit-response-messages').style.display = '';
			form.querySelector('.js-submit-response-messages').focus();
		};

		const handleErrorState = function() {
			var message = form.querySelector('.js-submit-response-error');
			setAccessibleMessage(message, 'alert');
			message.style.display = '';
			shakeForm(form);
		};

		const resetErrorMessages = function() {
			var message = form.querySelector('.js-submit-response-error');
			resetAccessibleMessage(message);
			message.style.display = 'none';
		};

		const handleSuccessState = function() {
			var message = form.querySelector('.js-submit-response-confirmation');
			setAccessibleMessage(message);
			message.style.display = '';
			form.setAttribute('data-submitted', 'true');
			form.querySelector('.js-submit-button').disabled = true;

			const closeButton = form.querySelector('.js-close-button');
			if (closeButton) {
				closeButton.style.display = '';
				closeButton.disabled = false;
			}
		};

		var request = new XMLHttpRequest();
		const action = type === 'request-demo' ? 'SendDemoRequestForm' : 'SendContactUsForm';
		request.open('POST', API_HOSTNAME + '/action?action=' + action, true)
		request.withCredentials = true;
		request.timeout = 30000;
		request.setRequestHeader('Content-Type', 'application/json');

		request.onerror = function() {
			trigger(submitButton, 'active');
			handleErrorState();
		}

		request.onreadystatechange = function() {
			// Request finished. Do processing here.
			if (this.readyState === XMLHttpRequest.DONE) {
				resetErrorMessages();
				trigger(submitButton, 'active');

				if (this.status === 200) {
					const response = JSON.parse(this.response);

					if (response.status === 'ok') {
						prepareResponseOverlayAfterSubmit();
						handleSuccessState();

						// GA tracking using Google Tag Manager
						dataLayer.push({
							'event': 'gaEvent',
							'eventCategory': type === 'request-demo' ? 'Demo forms' : 'Contact forms',
							'eventAction': 'Submit',
						});

						// we need to delay disabling of field to do that at the moment
						// once we will have visible overlay
						setTimeout(function() {
							makeFieldsDisabled(form);
							form.reset();
						}, 500);
					} else {
						handleErrorState();
					}
				} else {
					handleErrorState();
				}
			}
		}

		request.send(JSON.stringify(data));
	}



	/**
	 * Submit form with remarks
	 */

	var remarksForms = document.querySelectorAll('.js-submit-remarks');
	for (var i = 0 ; i < remarksForms.length; i++) {
		var remarksForm = remarksForms[i];

		remarksForm.setAttribute('data-submitted', 'false');

		remarksForm.addEventListener('formvalid', (ev) => {
			const details = ev.detail;
			const formEl = details.formElement;

			var isSubmitted = formEl.getAttribute('data-submitted') && formEl.getAttribute('data-submitted') == 'true';

			if (isSubmitted) {
				return false;
			}

			sendFormData(formEl);
		});

		remarksForm.addEventListener('submit', (ev) => {
			ev.preventDefault();

			return false;
		});
	}
})();
